import React, { Component } from 'react'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import EventRow from './EventRow.js'
import './event.css'
import TitleBar from '../TitleBar'

export default class Events extends Component {
  constructor(props) {
    super(props)
    const refreshButton = '<i class=\'fa fa-refresh\'></i>'
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    this.state = {
      events: this.props.events,
      refreshButton: refreshButton,
      backButton: backButton
    }
    // this.getEvents.bind(this)
    this.refresh = this.refresh.bind(this)
    this.props.setActiveTab('homepage')
    window.trackPage('EventsScreen')
  }

  refresh() {
    const refreshButton = '<i class=\'fa fa-refresh fa-spin\'></i>'
    this.setState({ refreshButton: refreshButton })
    this.props.getResource({
      key: 'events',
      update: true,
      callback: () => {
        this.setState({
          refreshButton: '<i class=\'fa fa-refresh\'></i>'
        })
      }
    })
  }

  getEvents() {
    var events = []
    var _this = this
    _.each(this.props.events.events, function(event){
      events.push(<div className="event-row" key={event.id}><EventRow changeEvent={_this.props.changeEvent} event={event} currentEvent={window.currentUser.current_event_id}/><p className="event-date">{event.formatted_display_date}</p><hr/></div>)
    })
    return events
  }

  render() {
    return (
      <div>
        <TitleBar
          title="Switch Events"
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh } />
        {this.getEvents()}
      </div>
    )
  }
}
